import { render, staticRenderFns } from "./BaseSeparator.vue?vue&type=template&id=40dc365f&"
var script = {}
import style0 from "./BaseSeparator.vue?vue&type=style&index=0&id=40dc365f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports